var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoCondominio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 25,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1542_2267",
    transform: "matrix(0.02 0 0 0.0216 0 -0.04)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1542_2267",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAACOElEQVR4nO2ay04UQRRAe8djg5jAAK70ayA4BrcI/8BEFL8B2ZCYaFjyCWMIqH9AMCwZ5+FOFgRcS4Qcc+NdTNqi7cft6q4JJ+lk0tNza0666nbVrY6ie0YU4CGwAuwAB0AH+Alc6yGfz/S7t3rtdFQHgHFgHfgC3JKdG+ATsCaxogoEJoBN4Bw7JNZLie1L4inwnfIYAMtld6Nd/LEPTFpLzAOn+OcEmLOSeKK3uyr68h+KSswCXapnkPvOaGaqojvdxddcKRrYoxjyEHwNLOixpeeK8D5Pii3KliOuyBRlKUuXshjc847Yc0aDfzyNyCtsWHDEfmQUu5XmoWc17XB1rTdGsX8k3hWdAFpxrWPCcrAP8yJJRGaxoXCUtJ6QaXUo3AAPXCLPCY9nLhFZ2YXGtktElqAmJIxBa9quRroBinRcjVxZt+JB5MIlYpnjfYn8GmmRq1HpWt0ARTqlpl+PIm0vD0QPItsuEanFhibSdIlMW08aSxb5DUz9I6INfQ5I5NApoQ1JVTwUkdUkkTFdRtZd5Py/BQgt7dddZCNRwqoclKKNIvRSVxxlf6LGIoupJIYa+0D9eJdJYqjGJfsTdeFYklFmEZWZAb5VbcDfMmkjl0Rso6dfscTjQhKx4rPsT1TRnRomErGHpe/N0AlTiZjQUsldrZc5xRaQkYzWspzOaKyNqt6AGNOJ5lHOJYD85lAq67lTqzVSUJZarKzagI/6As3l0Es1l3qurdc071xP3BOFzx+zEDxHsWn+CgAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCondominio);
export default __webpack_public_path__ + "static/media/info-condominio.463da8ee3b84ba118373353b5075547a.svg";
export { ForwardRef as ReactComponent };